/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { FormControl, FormHelperText, FormLabel, RadioGroup } from '@mui/material';
import { FormControlLabelProps } from '@mui/material/FormControlLabel';
import { checkFormHasError, getFormHelperText, handleChangeFormField } from 'ui/forms/formHelpers';
import { formGroupRoot, formHelperTextRoot, formLabelRoot } from 'ui/Radio/radioFormCssDefs';
import { useField } from 'formik';

export interface FormRadiobuttonGroupProps {
  children: React.ReactElement<FormControlLabelProps>[] | React.ReactElement<FormControlLabelProps>;
  disabled?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  label?: React.ReactNode;
  name: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  row?: boolean;
}

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const FormRadiobuttonGroup: React.FunctionComponent<
  React.PropsWithChildren<FormRadiobuttonGroupProps>
> = ({ children, disabled, fullWidth, helperText, label, row, ...rest }) => {
  const [field, meta] = useField(rest as any);

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(field, event, rest.onChange as any);

  const ariaLabel = typeof label === 'string' ? label : field.name;

  return (
    <FormControl component="fieldset" error={hasError} disabled={disabled} fullWidth={fullWidth}>
      {label && (
        <FormLabel css={formLabelRoot} component="legend">
          {label}
        </FormLabel>
      )}
      <RadioGroup
        css={formGroupRoot}
        aria-label={ariaLabel}
        name={field.name}
        value={field.value}
        onChange={handleChange}
        row={row}
      >
        {React.Children.map(children, (child) => {
          return React.cloneElement(child as any, { disabled });
        })}
      </RadioGroup>
      {helperTextValue && (
        <FormHelperText css={formHelperTextRoot}>{helperTextValue}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FormRadiobuttonGroup;
